import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Alert } from '../../../../design/alert/S_Alert';
import { S_Card } from '../../../../design/card/card/S_Cards';
import { S_Link } from '../../../../design/links/S_Link';
import { FormAlert } from '../../../components/FormAlert';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';
import { Auth } from '../../../routes/config/Auth';

interface IResetPasswordRequestFormProps {
  isDisabledSubmit: boolean;
  emailStatus: InputStatus;
  externalStatus: InputStatus;
  handleEmailChange: (value: string) => void;
  validateEmail: (value: string) => void;
  onRequestPasswordReset: () => Promise<void>;
}

export const ResetPasswordRequestForm = observer((props: IResetPasswordRequestFormProps): ReactElement => {
  const { t } = useTranslator();

  const validationErrorOccurred = props.externalStatus.isValid === false || props.emailStatus.isValid === false;

  return (
    <S_Card>
      <div className='form-heder'>{t('password_reset_request')}</div>
      {props.externalStatus.isValid && <S_Alert color='success'>{t('password_reset_email_sent')}</S_Alert>}
      <FormAlert
        errors={props.externalStatus}
        useDefaultMessageWhenCodeNotFound={true}
      />
      <div className='auth-form'>
        <ValidatedTextInput
          labelText={t('email_address')}
          type={'text'}
          placeholder={t('enter_email')}
          onChange={props.handleEmailChange}
          onBlur={props.validateEmail}
          onPressEnter={() => {
            void props.onRequestPasswordReset();
          }}
          isValid={props.emailStatus.isValid}
          feedbacks={props.emailStatus.errorCodes}
        />
        <Button
          onClick={() => {
            void props.onRequestPasswordReset();
          }}
          disabled={validationErrorOccurred || props.isDisabledSubmit}
        >
          {t('send_reset_password_request')}
        </Button>
      </div>
      <div className='auth-link'>
        {t('no_account')}
        <S_Link
          color='anchor'
          to={Auth.Register.Path}
        >
          {t('no_account_with_link')}
        </S_Link>
      </div>
    </S_Card>
  );
});
